import React from 'react';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';

import { PureComponent, Page } from 'core/components';
import { withLocale } from 'core/decorators';
import { CategoryList } from 'content/components';

import translations from './i18n';

class CategoryPage extends PureComponent {
  constructor(props) {
    super(props);

    this.props.translator.addModuleResource('category', translations);
  };

  render() {
    const { category, navigate } = this.props;

    return (
      <Page
        pageName="category"
        showCart={true}
        showSearch={true}
        showBack={false}
        navigate={navigate}
      >
        <CategoryList
          items={category}
        />
      </Page>
    );
  };
};

export default connect(
  state => ({
    category: state.Category.category
  }),
  {
  }
)(withLocale('category')(autobind(CategoryPage)));
